import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActionsOperators } from '../../../data-rules-model';
import { DataRulesService } from '../../../data-rules.service';
import { AddressFieldAppendComponent } from './address-field-append/address-field-append.component';
import { AddressFieldFormatComponent } from './address-field-format/address-field-format.component';
import { AddressFieldNullifyComponent } from './address-field-nullify/address-field-nullify.component';
import { AddressFieldPrependComponent } from './address-field-prepend/address-field-prepend.component';
import { AddressFieldReplaceComponent } from './address-field-replace/address-field-replace.component';
import { AddressFieldSubstituteComponent } from './address-field-substitute/address-field-substitute.component';

@Component({
  selector: 'app-address-field-action',
  templateUrl: './address-field-action.component.html',
  imports: [
    NgSwitch,
    AddressFieldAppendComponent,
    NgSwitchCase,
    AddressFieldNullifyComponent,
    AddressFieldPrependComponent,
    AddressFieldReplaceComponent,
    AddressFieldSubstituteComponent,
    AddressFieldFormatComponent
  ],
  styleUrls: ['../address-action.component.scss']
})
export class AddressFieldActionComponent implements OnInit {
  @Input() fieldControl: FormControl;
  @Input() checkBoxControl: FormControl;
  @Input() fieldLabel: string;
  @Input() actionType: ActionsOperators;
  @Input() iconName: string;

  public actionOps: typeof ActionsOperators = ActionsOperators;

  constructor(public dataRulesService: DataRulesService) {
  }

  ngOnInit(): void {
  }

}
